export default __webpack_public_path__ + "static/Quickinstallation_Tile_8015_Step_08-3b6fdd08fb2cf25ba90a938a0b5cff70.webp";